import { useEffect } from 'react';
import { BillingInformation } from '../models/BillingInformation.interface';
import { billingInformationsState, getBillingInformation } from "../billingInformationsSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux/hooks";


export const useInformation = (): [boolean, BillingInformation | null] => {
    const dispatch = useAppDispatch();
    const { billingInformation: { isLoading, informations } } = useAppSelector(billingInformationsState);

    useEffect(() => {
        dispatch(getBillingInformation());
    }, []);

    return [isLoading, informations]

}